<template>
  <div class="h-full flex items-center lg:px-2">
    <div class="relative hidden sm:flex" role="search">
      <label for="header-search-input" class="sr-only">{{ $t('search.inputPlaceholder') }}</label>
      <input
        id="header-search-input"
        type="search"
        :value="searchQuery"
        class="hidden lg:block search-input border bg-putty rounded-full h-8 pl-8 border-transparent pr-4 w-auto fluid-xs leading-tightest"
        :placeholder="$t('search.inputPlaceholder')"
        @click="handleInputFocus"
        @input="handleInputFocus"
        :aria-label="$t('search.aria.searchInput')"
      />
      <button
        class="flex items-center justify-center w-8 h-8 lg:text-br-green lg:absolute top-0 left-0 ml-1 text-blackly search-button z-[2]"
        @click="handleInputFocus"
        :aria-label="$t('search.aria.openSearch')"
      >
        <SearchIcon class="w-5 h-5" />
      </button>
    </div>

    <!-- Show Search icon for mobile users if search has been closed -->
    <button
      v-if="isHidden"
      class="flex sm:hidden items-center justify-center w-8 h-8 text-blackly animate-flash"
      @click="unhide"
      :aria-label="$t('search.aria.openMobileSearch')"
    >
      <SearchIcon class="w-5 h-5" />
    </button>

    <ClientOnly>
      <SearchModal />
    </ClientOnly>
  </div>
</template>

<script setup>
import SearchIcon from '@/components/icons/SearchIcon';
import SearchModal from '@/components/search/SearchModal';
import { useSearchStore } from '@/stores/search';
import { useRoute } from 'vue-router';

const route = useRoute();
const searchStore = useSearchStore();

const searchQuery = computed(() => searchStore.searchQuery);
const isHidden = computed(() => searchStore.isHidden);

const open = () => searchStore.open();
const setQuery = (query) => searchStore.setQuery(query);
const unhide = () => searchStore.unhide();

const handleInputFocus = (event) => {
  document.activeElement.blur();
  if (event.target.value) {
    setQuery(event.target.value);
  }
  nextTick(() => {
    open();
  });
};

onMounted(() => {
  setQuery(route.query.query ?? '');
});
</script>

<style scoped>
@reference "~/assets/css/main.css";
.search-input::-webkit-search-decoration,
.search-input::-webkit-search-cancel-button,
.search-input::-webkit-search-results-button,
.search-input::-webkit-search-results-decoration {
  @apply hidden;
}
.search-input {
  @apply appearance-none;
}
.search-input:focus + .search-button {
  @apply text-br-green;
}
</style>
